export const CSR_IMPACT_PLACEHOLDERS = {
  soilScore: { before: 0, after: 0 },
  income: { before: 0, after: 0, delta: 0, pct: 0 },
  fertilizerReductionPct: 0,
  ipmPct: 0,
  plotsRetestedPct: 0,
};